"use strict";const e=require("./SimpleDropdown.js");module.exports=e;
//# sourceMappingURL=index.js.map
